"use client";
import { printStyle, r } from "@/functions/fns";

export default function PreviewItem({
  duration,
  bg,
  config,
  className,
  animationType,
  children,
}) {
  duration = duration || "25s";
  const id = "z-" + r(0, 9999999);
  const style = printStyle(config, id, bg, duration, animationType);

  return (
    <>
      <div id={id} className={className}>
        {children}
      </div>
      <style>{style}</style>
    </>
  );
}
